/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {Company} from "types/entities/Company";
import React from "react";
import TableColumn from "pages/Front/components/Table/TableColumn";
import TableRow from "pages/Front/components/Table/TableRow";

export const CompanyItem = (props: {company: Company; onClick: () => void}) => {
    return (
        <TableRow
            className={"hover:bg-blue-400 hover:text-white hover:cursor-pointer"}
            onClick={props.onClick}
        >
            <TableColumn>{props.company.name || "---"}</TableColumn>
            <TableColumn>{props.company.first_name || "---"}</TableColumn>
            <TableColumn>{props.company.last_name || "---"}</TableColumn>
            <TableColumn>{props.company.street_address || "---"}</TableColumn>
            <TableColumn>{props.company.city || "---"}</TableColumn>
            <TableColumn>{props.company.email || "---"}</TableColumn>
        </TableRow>
        // <tr
        //     className={"CompanyItem even:bg-gray-50 border-b border-b-gray-200/50 last:border-b-0 hover:bg-arbo-red hover:text-white group cursor-pointer last:!rounded-bl-xl last:!rounded-br-xl"}
        //     onClick={props.onClick}
        // >
        //     <td className={"pl-3 pr-1.5 py-2 group-last:rounded-bl-xl"}>{props.company.name || "---"}</td>
        //     <td className={"px-1.5 py-2"}>{props.company.first_name || "---"}</td>
        //     <td className={"px-1.5 py-2"}>{props.company.last_name || "---"}</td>
        //     <td className={"px-1.5 py-2"}>{props.company.street_address || "---"}</td>
        //     <td className={"px-1.5 py-2"}>{props.company.city || "---"}</td>
        //     <td className={"pl-1.5 pr-3 py-2 group-last:rounded-br-xl"}>{props.company.email || "---"}</td>
        // </tr>
    );
};
